import { FC } from "react";
import { COLORS } from "shared/consts";

type NotificationTemperatureIconProps = {
  fill?: string;
}
export const NotificationTemperatureIcon: FC<NotificationTemperatureIconProps> = ({
  fill = COLORS.ACCENT.DEFAULT
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.85144 12.786L7.21032 13.2338C6.17271 13.9584 5.5 15.1552 5.5 16.5078C5.5 18.7107 7.28886 20.5001 9.5 20.5001C11.7111 20.5001 13.5 18.7107 13.5 16.5078C13.5 15.1552 12.8273 13.9584 11.7897 13.2338L11.1486 12.786V12.004V5.14856C11.1486 4.23808 10.4105 3.5 9.5 3.5C8.58953 3.5 7.85144 4.23808 7.85144 5.14856V12.004V12.786ZM6.35144 5.14856C6.35144 3.40966 7.7611 2 9.5 2C11.2389 2 12.6486 3.40966 12.6486 5.14856V12.004C14.0702 12.9969 15 14.6439 15 16.5078C15 19.5411 12.5376 22.0001 9.5 22.0001C6.46243 22.0001 4 19.5411 4 16.5078C4 14.6439 4.92978 12.9969 6.35144 12.004V5.14856ZM16.75 7.25V9H18.25V7.25H20V5.75H18.25V4H16.75V5.75H15V7.25H16.75ZM15 12.4854H20V10.9854H15V12.4854Z" fill={fill}/>
    </svg>
  )
}